module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-container"
  }, [_c('div', {
    staticClass: "title-with-selector h3-selector"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_c('b', [_vm._v(_vm._s('Slide ' + _vm.slide.order))])]), _vm._v(" "), _c('state-selector', {
    attrs: {
      "selected": _vm.slide ? parseInt(_vm.slide.state_id) : null,
      "target": _vm.slide,
      "update": 'slide'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('b', [_vm._v("Descrição [PT]")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText.pt.description)
    }
  }), _vm._v(" "), (!_vm.htmlText.pt.description) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), (_vm.showPlusDetail) ? _c('div', {
    staticClass: "column is-6"
  }, [_c('b', [_vm._v("Mais Detalhes [PT]")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText.pt.plus_detail)
    }
  }), _vm._v(" "), (!_vm.htmlText.pt.plus_detail) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('b', [_vm._v("Descrição [EN]")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText.en.description)
    }
  }), _vm._v(" "), (!_vm.htmlText.en.description) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), (_vm.showPlusDetail) ? _c('div', {
    staticClass: "column is-6"
  }, [_c('b', [_vm._v("Mais Detalhes [EN]")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText.en.plus_detail)
    }
  }), _vm._v(" "), (!_vm.htmlText.en.plus_detail) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('b', [_vm._v("Descrição [ES]")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText.es.description)
    }
  }), _vm._v(" "), (!_vm.htmlText.es.description) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), (_vm.showPlusDetail) ? _c('div', {
    staticClass: "column is-6"
  }, [_c('b', [_vm._v("Mais Detalhes [ES]")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText.es.plus_detail)
    }
  }), _vm._v(" "), (!_vm.htmlText.es.plus_detail) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('b', [_vm._v("Descrição [FR]")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText.fr.description)
    }
  }), _vm._v(" "), (!_vm.htmlText.fr.description) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), (_vm.showPlusDetail) ? _c('div', {
    staticClass: "column is-6"
  }, [_c('b', [_vm._v("Mais Detalhes [FR]")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText.fr.plus_detail)
    }
  }), _vm._v(" "), (!_vm.htmlText.fr.plus_detail) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [(_vm.slide.foreground_path_1) ? _c('div', {
    staticClass: "column is-6"
  }, [_vm._m(0), _vm._v(" "), (_vm.isVideo(_vm.slide.foreground_path_1)) ? _c('figure', {
    staticClass: "image"
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "controls": "",
      "id": ("video-" + (_vm.slide.id))
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.slideImagePath + _vm.slide.foreground_path_1,
      "type": "video/mp4"
    }
  }), _vm._v("\n          Your browser does not support the video tag.\n        ")])]) : _c('figure', {
    staticClass: "image coach-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.slideImagePath + _vm.slide.foreground_path_1
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.slide.foreground_path_2 && !_vm.isVideo(_vm.slide.foreground_path_1)) ? _c('div', {
    staticClass: "column is-6"
  }, [_vm._m(1), _vm._v(" "), _c('figure', {
    staticClass: "image coach-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.slideImagePath + _vm.slide.foreground_path_2
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "control has-addons"
  }, [_c('b', {
    staticClass: "inline-lable"
  }, [_vm._v("Posição:")]), _vm._v(" "), _c('a', {
    staticClass: "button is-small",
    class: {
      'is-disabled': _vm.slide.order == 1
    },
    on: {
      "click": function($event) {
        _vm.reorderSlides(1)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Topo")])]), _vm._v(" "), _c('a', {
    staticClass: "button is-small",
    class: {
      'is-disabled': _vm.slide.order == 1
    },
    on: {
      "click": function($event) {
        _vm.reorderSlides(parseInt(_vm.slide.order) - 1)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("-1")])]), _vm._v(" "), _c('a', {
    staticClass: "button is-small",
    class: {
      'is-disabled': _vm.slide.order == _vm.slideTotal
    },
    on: {
      "click": function($event) {
        _vm.reorderSlides(parseInt(_vm.slide.order) + 1)
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("+1")])]), _vm._v(" "), _c('a', {
    staticClass: "button is-small",
    class: {
      'is-disabled': _vm.slide.order == _vm.slideTotal
    },
    on: {
      "click": function($event) {
        _vm.reorderSlides(_vm.slideTotal)
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Fundo")])])]), _vm._v(" "), (!_vm.slide.sub_menu && !_vm.slide.parent_id && _vm.showSubMenu) ? _c('a', {
    staticClass: "button is-small is-info",
    on: {
      "click": _vm.openSlideSetEditModal
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Adicionar Sub-slides")])]) : _vm._e(), _vm._v(" "), (_vm.slide.sub_menu) ? _c('a', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.openSlideSetDeleteModal
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Apagar Sub-slides")])]) : _vm._e(), _vm._v(" "), (_vm.slide.sub_menu) ? _c('a', {
    staticClass: "button is-small is-info",
    on: {
      "click": _vm.goToSubSlide
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', [_vm._v("Sub-slides")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button is-small is-primary",
    on: {
      "click": _vm.openSlideEditModal
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Editar")])]), _vm._v(" "), _c('a', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.openSlideDeleteModal
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Apagar")])]), _vm._v(" "), _c('hr')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Foreground 1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Foreground 2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-074c1496!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide/LevelSlide.vue
// module id = 301
// module chunks = 1